'use client';

import type { PropsWithChildren, ReactNode } from 'react';
import { Suspense } from 'react';
import { AppAlertBanner } from '@frameio/app-alert-banner/components';
import { WatermarkSelectionDialog } from '@frameio/content-security/watermarking/components';
import { OpenOnDesktopDialogs } from '@frameio/finder-menu-bar/components/FinderMenuBar/OpenOnDesktop';
import { handleGlobalErrors } from '@frameio/next-shared/utils';
import { QuickSearch } from '@frameio/quick-search/components/QuickSearch';
import { QuickSearch as QuickSearchV2 } from '@frameio/search';
import { Onboarding } from '@frameio/shared/onboarding';
import { Quickshare } from '@frameio/shares/quickshare/components/Quickshare';
import { AuthenticatedGridTemplate } from './_components/AuthenticatedGridTemplate';
import { AuthenticatedProviders } from './_components/AuthenticatedProviders';
import { FeedbackDialogWithIntegrationsData } from './_components/FeedbackDialogWithIntegrationsData';
import { MainAppAnalytics } from './_components/MainAppAnalytics';

type AuthenticatedLayoutProps = PropsWithChildren<{
  /**
   * The @tabs parallel route component to render in the layout
   */
  tabs?: ReactNode;
}>;

export default function AuthenticatedLayout({
  children,
  tabs,
}: AuthenticatedLayoutProps) {
  try {
    return (
      <Suspense fallback={null}>
        <AuthenticatedProviders>
          <AuthenticatedGridTemplate>
            {tabs}
            <AppAlertBanner />
            {children}
          </AuthenticatedGridTemplate>
          <QuickSearch />
          <QuickSearchV2 />
          <Quickshare />
          <FeedbackDialogWithIntegrationsData />
          <MainAppAnalytics />
          <OpenOnDesktopDialogs />
          <WatermarkSelectionDialog />
          <Onboarding />
        </AuthenticatedProviders>
      </Suspense>
    );
  } catch (e) {
    return handleGlobalErrors(e);
  }
}
